var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBars = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 135 140",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.5s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.5s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.25s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.25s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 60,
  width: 15,
  height: 140,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 90,
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.25s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.25s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 120,
  y: 10,
  width: 15,
  height: 120,
  rx: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  begin: "0.5s",
  dur: "1s",
  values: "120;110;100;90;80;70;60;50;40;140;120",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  begin: "0.5s",
  dur: "1s",
  values: "10;15;20;25;30;35;40;45;50;0;10",
  calcMode: "linear",
  repeatCount: "indefinite"
}))));
export default SvgBars;